import React from 'react';
import { currencyToWordsParts, displayValue, formatCurrency, getAdministratorName, getAssignorDocument, getBankName, getIntermediaryName, getPaymentPixText, getPhone, getReceiptValue, QuotaLineList } from './documentHelpers';

export default function ReceiptDocument({ acquisition }) {
    const receiptValue = getReceiptValue(acquisition);
    const receiptValueText = currencyToWordsParts(receiptValue);
    const assignorDocument = getAssignorDocument(acquisition);
    const isCnpj = acquisition.doc_type === 'CNPJ';

    return (
        <div className='intermediary-document-paper'>
            <p className='intermediary-document-title'><u><b>RECIBO - {formatCurrency(receiptValue)}</b></u></p>

            <p>
                Declaro haver recebido da empresa OBJETIVA - SOLUÇÕES EM CONSÓRCIO
                S/S LTDA., com sede na Rua Espírito Santo, nº 273, bairro Aclimação, São
                Paulo - SP, inscrita no CNPJ/MF nº 13.282.501/0001-50, a importância
                mencionada de R$ {formatCurrency(receiptValue).replace('R$', '').trim()} ({receiptValueText.reais} reais{receiptValueText.centavos}), referente a
                cessão que lhe faço nesta data de todos os meus direitos creditórios sobre a(s)
                cota(s) de consórcio CANCELADA do(s) grupo(s) administrado(s) pela
                {' '}{displayValue(getAdministratorName(acquisition))}, abaixo especificada(s):
            </p>

            <QuotaLineList quotas={acquisition.quotas} />

            <p>Para depósito do valor combinado, indico a instituição financeira abaixo:</p>

            <p>
                 {getPaymentPixText(acquisition) && (
                    <>
                        {getPaymentPixText(acquisition)} <br />
                    </>
                )}
                Banco: {displayValue(getBankName(acquisition))} <br />
                Agência: {displayValue(acquisition.bank_account_agency)} <br />
                Conta: {displayValue(acquisition.bank_account_number)} <br />
                Tipo: {displayValue(acquisition.bank_account_type)} <br />
                Nome: <span id='nome_cedente'>{displayValue(acquisition.bank_account_name)}</span> <br />
                CPF/CNPJ: {displayValue(acquisition.bank_account_doc_number)}<br />
            </p>

            <p>
                Pelo presente recibo dou plena, rasa e irrevogável quitação em relação a
                importância recebida, como sendo a justa e combinada, nada mais tendo a
                reclamar, sob qualquer pretexto, em razão do negócio celebrado.
            </p>

            <p>
                Integra a presente negociação, procuração pública outorgada pelo(a)
                consorciado(a) cedente dando poderes para a OBJETIVA representá-lo(a) perante
                a <b>{displayValue(getAdministratorName(acquisition))}</b>. para, em
                especial, vender, ceder ou transferir para o seu próprio nome ou a quem convier
                a(s) cota(s) de consórcio objeto da presente negociação ou receber todos e
                quaisquer valores de créditos referente(s) a(s) cota(s) objeto da presente
                negociação.
            </p>

            <p>
                Por fim, declaro que a(s) cota(s) de consórcio objeto da presente negociação
                NUNCA foi (foram) objeto de qualquer outra negociação. A presente declaração é
                feita sob as penas da Lei, ciente que a falsa declaração importa em
                responsabilidade criminal nos termos do artigo 299 do Código Penal Brasileiro.
            </p>

            <br />

            <p>{displayValue(acquisition.registry_city || acquisition.address_city)},</p>

            <p>
                _________________________________________ <br />
                Nome: {displayValue(getIntermediaryName(acquisition))}
            </p>
            <p>
                CPF/CNPJ: Nº: {isCnpj ? displayValue(acquisition.cnpj_number) : displayValue(acquisition.cpf_number)}<br />
                Fones: {displayValue(getPhone(acquisition))}
            </p>

            <p>*Reconhecer firma da assinatura por autenticidade</p>

            <p hidden id='documento'>{displayValue(acquisition.doc_type)} {displayValue(assignorDocument)}</p>
        </div>
    );
}

